import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { PainelinsumoService } from '../../../services/painelinsumo.service';
import { ToastService } from '../../../services/toast.service';
import { OrdemInsumo } from '../../../types/OrdemInsumo.type';

@Component({
  selector: 'app-painel',
  templateUrl: './painel.component.html',
  styleUrl: './painel.component.css'
})
export class PainelComponent implements OnInit{
  ordens: OrdemInsumo[] = []
  loading: boolean = false

  itemsMenu!: MenuItem[];

  apenasAbertas: boolean = true;

  constructor(private painelService: PainelinsumoService, private toastService: ToastService) {
    this.itemsMenu = [
      {
        label: 'PDF',
        command: () => {this.downloadRelatorio("PDF")}
      },
      {
        label: 'Excel',
        command: () => {this.downloadRelatorio("EXCEL")}
      }
    ]
  }

  ngOnInit() {
    this.getOrdens();
  }

  getOrdens(){
    this.loading = true
    this.painelService.getOrdens(this.apenasAbertas).subscribe({
      next: (data) => {
        this.ordens = data;
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao buscar as informações: " + error.error.message);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  atualizarOrdens(){
    this.loading = true

    this.painelService.getSyncOrdens().subscribe({
      next: () => {
        this.getOrdens();
        this.toastService.sucesso("Sincronização", "Sincronização realizada")
      },
      error: (error) => {
        this.toastService.erro("Erro", error.error.message)
      },
      complete: () => {
        this.loading = false
      }
    })
  }

  downloadRelatorio(tipo: string) {
    this.painelService.getRelatorio(tipo).subscribe(response => {

      let nomeArquivo = "";

      switch(tipo){
        case "PDF":
          nomeArquivo = "relatorio.pdf"
          break
        case "EXCEL":
          nomeArquivo = "relatorio.xlsx"
      }
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a')
      a.href = url
      a.download = nomeArquivo
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a);
    }, error => {
      console.error('Erro ao baixar o relatório', error)
    })

  }

  statusOrdem(fgStatus: string) {

    let retorno = "";
    switch(fgStatus){
      case "F":
        retorno = "Fechada";
        break;
      case "E":
        retorno = "Excluída";
        break;
      case "A":
        retorno = "Aberta";
    }

    return retorno;
  }
}
